import "./customtab.scss"
import * as React from "react";

export interface ICustomTab {
    id: number
    title: string
    activate: string
    setActivate: React.Dispatch<React.SetStateAction<string>>
}

const CustomTab = ({id, title, activate, setActivate}: ICustomTab) => {
    return (
        <div onClick={() => {
            setActivate(`tab${id}`)
        }} className={activate === `tab${id}` ? "Custom-Tab active" : "Custom-Tab"}>
            {title}
        </div>
    )
}

export default CustomTab